module.exports = __webpack_public_path__ + "r-v3/img/chatbot_white.5a4685cd.png";